import { inputCls } from "./Fields";
import { SubBadge } from "@/components/admin/SectionShell";

export const WelcomeMessagePanel = ({ content, setC }) => (
  <div data-testid="registration-whatsapp-panel" className="mt-6 rounded-2xl border border-border bg-white/60 p-4">
    <p className="text-sm font-medium"><SubBadge /> Email copy of the welcome</p>
    <p className="text-xs text-muted-foreground mt-1 mb-3">
      On registration the <span className="font-medium text-foreground">same Welcome template</span> chosen above is sent to the participant's WhatsApp number and emailed to them (subject: Registration successful — Positive Life @SSVS).
      The text below is used for the email only if the template cannot be loaded from Meta.
    </p>
    <label className="block text-xs uppercase tracking-widest text-muted-foreground">Fallback email text · placeholders: {"{name} {program} {batch} {place}"}</label>
    <textarea rows={4} data-testid="content-registration_welcome_message" value={content.registration_welcome_message || ""} onChange={(e) => setC("registration_welcome_message", e.target.value)} className={`${inputCls} resize-y`} />
  </div>
);
